import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Icon } from '../../../../common/html/icon'
import { Panel } from '../../../../common/panel'
import { Tooltip } from '../../../../common/tooltip'
import { selectCompanyInfo } from '../../../common/header/companyInfo/store/slice'
import { TopComparablePlayers as TopComparablePlayersContent } from '../../../summary/panels/topComparablePlayers'
import { selectTopComparablePlayers } from '../../../summary/store/slice'
import {
  downloadTopComparablePlayers,
  getTopComparablePlayers,
} from '../../../summary/store/thunk'

export const TopComparablePlayers = () => {
  const dispatch = useDispatch()
  const { organizationId } = useSelector(selectCompanyInfo)
  const data = useSelector(
    selectTopComparablePlayers((comparablePlayers) => comparablePlayers.data),
  )

  useEffect(() => {
    if (organizationId) {
      dispatch(getTopComparablePlayers({ OrganizationId: organizationId }))
    }
  }, [dispatch, organizationId])

  return (
    <Panel
      isI18n
      height={366}
      label="companySummary.TOP_COMPARABLE_PLAYERS"
      renderLabel={() => (
        <Tooltip
          tooltipContent="companySummary.topComparablePlayers.TOOLTIP_TITLE"
          translateProps={{ dangerousHTML: true }}
          isI18n
          contentClass="ml1 dFlex"
          tooltipContentStyle={{ maxWidth: 500 }}
        >
          <Icon
            className="icon-info-circle"
            style={{ color: '#9C9C9C', fontSize: 16 }}
          />
        </Tooltip>
      )}
      downloadCsv={{
        disabled: !data.length,
        downloadFunc: () =>
          downloadTopComparablePlayers({ OrganizationId: organizationId }),
      }}
    >
      <TopComparablePlayersContent />
    </Panel>
  )
}
